import { styled } from 'styletron-react';

const Footer = styled('footer', {
  display: 'flex',
  justifyContent: 'center',
});

export { Footer };
